import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import TextEditor from "../../Components/TextEditor/TextEditor";
import { AuthContext } from "../../../Provider/AuthProvider";
import AdminNavbar from "../../Components/AdminNavbar/AdminNavbar";
import Footer from "../../../components/footer/Footer";
import { BiSolidHome } from "react-icons/bi";

const EditProductInfo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [sections, setSections] = useState([{ title: "", content: "" }]);
  const [photos, setPhotos] = useState([null, null, null, null]);

  const [product, setProduct] = useState(null);
  const [editorHtml, setEditorHtml] = useState("");
  const [photo1Url, setPhoto1Url] = useState("");
  const [photo2Url, setPhoto2Url] = useState("");
  const [photo3Url, setPhoto3Url] = useState("");
  const [photo4Url, setPhoto4Url] = useState("");
  const [productDetailsPhotoUrl, setProductDetailsPhotoUrl] = useState("");

  const imgbbApiKey = "372772eac972cb5bc94f6a3995c54b8e";

  useEffect(() => {
    fetch(`https://backend-server-nine-opal.vercel.app/contents/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setProduct(data);
        setSections(data.richTexts || [{ title: "", content: "" }]);
        setPhoto1Url(data.photo1 || "");
        setPhoto2Url(data.photo2 || "");
        setPhoto3Url(data.photo3 || "");
        setPhoto4Url(data.photo4 || "");
        setProductDetailsPhotoUrl(data.Product_Details_Photo || "");
      });
  }, [id]);

  const uploadImageToImgBB = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch(
      `https://api.imgbb.com/1/upload?key=${imgbbApiKey}`,
      {
        method: "POST",
        body: formData,
      },
    );
    const data = await res.json();
    if (data.success) {
      return data.data.url;
    } else {
      throw new Error("Image upload failed");
    }
  };

  const handlePhotoUpload = async (e, setPhotoUrl) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const url = await uploadImageToImgBB(file);
      setPhotoUrl(url);
      Swal.fire("✅ Photo updated!");
    } catch {
      Swal.fire("❌ Photo upload failed!");
    }
  };

  const handleRemovePhoto = (e, setPhotoUrl, inputId) => {
    e.preventDefault();
    e.stopPropagation();
    setPhotoUrl("");
    if (inputId) {
      const inputElem = document.getElementById(inputId);
      if (inputElem) inputElem.value = "";
    }
  };

  const handleSectionTitleChange = (index, title) => {
    const updated = [...sections];
    updated[index].title = title;
    setSections(updated);
  };

  const handleSectionContentChange = (index, html) => {
    const updated = [...sections];
    updated[index].content = html;
    setSections(updated);
  };

  const addSection = () => {
    setSections([...sections, { title: "", content: "" }]);
  };

  const removeSection = (index) => {
    const updated = [...sections];
    updated.splice(index, 1);
    setSections(updated);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    const form = event.target;

    const updatedProduct = {
      Product_name: form.Product_name.value,
      Pack_Size: form.Pack_Size.value,
      brand_Name: form.brand_Name.value,
      product_Category: form.product_Category.value,
      Net_Wt: form.Net_Wt.value,
      Gross_Wt: form.Gross_Wt.value,
      Carton_Dim: form.Carton_Dim.value,
      html: editorHtml,
      photo1: photo1Url,
      photo2: photo2Url,
      photo3: photo3Url,
      photo4: photo4Url,
      Product_Details_Photo: productDetailsPhotoUrl,
      richTexts: sections, // ✅ Save all sections here
    };

    try {
      const response = await fetch(
        `https://backend-server-nine-opal.vercel.app/contents/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedProduct),
        },
      );

      const result = await response.json();

      if (result.modifiedCount > 0) {
        Swal.fire({
          title: "✅ Success",
          text: "Product info updated successfully!",
          icon: "success",
        });
        navigate("/dashboard");
      } else {
        Swal.fire({
          title: "⚠️ Warning",
          text: "No changes were made.",
          icon: "warning",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      Swal.fire({
        title: "❌ Error",
        text: "Failed to update product. Please try again.",
        icon: "error",
      });
    }
  };

  if (!product) return <div>Loading...</div>;

  return (
    <div>
      <AdminNavbar />
      <div className="container mx-auto">
        <div className="text-sm breadcrumbs">
          <ul>
            <li>
              <Link to="/">
                <BiSolidHome className="text-lg" />
                <span className="flex items-center">Home</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard">
                <span className="flex items-center">Dashboard</span>
              </Link>
            </li>
            <li>Edit Product Info</li>
          </ul>
        </div>
        <div className="mx-auto bg-[#e7e7e7] mt-4 lg:p-16 p-4 rounded-2xl">
          <h1 className="lg:text-3xl text-xl text-center font-bold text-gray-900">
            Edit Product Info
          </h1>
          <form className="py-6" onSubmit={handleUpdate}>
            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-semibold text-gray-900">
                  Product Name
                </label>
                <input
                  type="text"
                  name="Product_name"
                  defaultValue={product.Product_name}
                  className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900">
                  Pack Size
                </label>
                <input
                  type="text"
                  name="Pack_Size"
                  defaultValue={product.Pack_Size}
                  className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold leading-6 text-gray-900">
                  Brand Name
                </label>
                <div className="">
                  <select
                    name="brand_Name"
                    defaultValue={
                      product.brand_Name?.replace(/_/g, " ") ||
                      product.brand_Name
                    }
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  >
                    <option disabled>Select A Brand</option>
                    <option value="Crown Farms">Crown Farms</option>
                    <option value="Rosemco">Rosemco</option>
                    <option value="Zoy">Zoy</option>
                    <option value="Saidowla">Saidowla</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900">
                  Product Category
                </label>
                <select
                  name="product_Category"
                  defaultValue={product.product_Category}
                  className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                >
                  <option value="Snacks">Snacks</option>
                  <option value="Fish">Fish</option>
                  <option value="Paratha">Paratha</option>
                  <option value="Vegetables">Vegetables</option>
                  <option value="Bakery & Sweets">Bakery & Sweets</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900">
                  Net Wt. (Kg)
                </label>
                <input
                  type="text"
                  name="Net_Wt"
                  defaultValue={product.Net_Wt}
                  className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900">
                  Gross Wt. (Kg)
                </label>
                <input
                  type="text"
                  name="Gross_Wt"
                  defaultValue={product.Gross_Wt}
                  className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>
              <div className="col-span-1">
                <label className="block text-sm font-semibold text-gray-900">
                  Carton Dim. (cm)
                </label>
                <input
                  type="text"
                  name="Carton_Dim"
                  defaultValue={product.Carton_Dim}
                  className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                />
              </div>
              {/* All Photo Uploads in One Row */}
              <div className="sm:col-span-2 mt-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Product Photos
                </label>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
                  {/* Product Details Photo */}
                  <div className="flex flex-col items-center border rounded-lg p-4 shadow-sm bg-white hover:shadow-md transition">
                    <div className="relative w-32 h-32">
                      <label
                        htmlFor="productDetailsPhoto"
                        className="w-32 h-32 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer text-gray-500 hover:text-indigo-600 hover:border-indigo-400 transition text-sm overflow-hidden"
                      >
                        {productDetailsPhotoUrl ? (
                          <img
                            src={productDetailsPhotoUrl}
                            alt="Details"
                            loading="lazy"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        ) : (
                          <>
                            <svg
                              className="w-6 h-6 mb-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 4v16m8-8H4"
                              />
                            </svg>
                            <span>Upload</span>
                          </>
                        )}
                      </label>
                      {productDetailsPhotoUrl && (
                        <button
                          type="button"
                          title="Remove photo"
                          onClick={(e) =>
                            handleRemovePhoto(
                              e,
                              setProductDetailsPhotoUrl,
                              "productDetailsPhoto",
                            )
                          }
                          className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 shadow-md transition z-10"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      )}
                    </div>
                    <input
                      id="productDetailsPhoto"
                      type="file"
                      onChange={(e) =>
                        handlePhotoUpload(e, setProductDetailsPhotoUrl)
                      }
                      className="hidden"
                    />
                    <p className="mt-2 text-sm text-gray-500">
                      Product Details Photo
                    </p>
                  </div>

                  {/* 4 Product Photos */}
                  {[1, 2, 3, 4].map((n) => {
                    const currentUrl = [
                      photo1Url,
                      photo2Url,
                      photo3Url,
                      photo4Url,
                    ][n - 1];
                    const setUrl = [
                      setPhoto1Url,
                      setPhoto2Url,
                      setPhoto3Url,
                      setPhoto4Url,
                    ][n - 1];
                    const inputId = `photo-${n}`;

                    return (
                      <div
                        key={n}
                        className="flex flex-col items-center border rounded-lg p-4 shadow-sm bg-white hover:shadow-md transition"
                      >
                        <div className="relative w-32 h-32">
                          <label
                            htmlFor={inputId}
                            className="w-32 h-32 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer text-gray-500 hover:text-indigo-600 hover:border-indigo-400 transition text-sm overflow-hidden"
                          >
                            {currentUrl ? (
                              <img
                                src={currentUrl}
                                loading="lazy"
                                alt={`Product view ${n}`}
                                className="w-full h-full object-cover rounded-lg"
                              />
                            ) : (
                              <>
                                <svg
                                  className="w-6 h-6 mb-1"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                                <span>Upload</span>
                              </>
                            )}
                          </label>
                          {currentUrl && (
                            <button
                              type="button"
                              title="Remove photo"
                              onClick={(e) =>
                                handleRemovePhoto(e, setUrl, inputId)
                              }
                              className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 shadow-md transition z-10"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                        <input
                          id={inputId}
                          type="file"
                          onChange={(e) => handlePhotoUpload(e, setUrl)}
                          className="hidden"
                        />
                        <p className="mt-2 text-sm text-gray-500">Photo {n}</p>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* ✅ Text Editor */}
              <div className="sm:col-span-2">
                <label className="block font-semibold text-gray-900 mb-4">
                  Product Details Sections
                </label>

                {sections.map((section, index) => (
                  <div
                    key={index}
                    className="border p-4 mb-6 rounded-md bg-white"
                  >
                    <h1 className="text-lg text-left font-semibold">
                      Tab Name
                    </h1>
                    <div className="flex justify-between items-center">
                      <input
                        type="text"
                        placeholder="Section Title (e.g.: Nutritional Information, Specifications, Allergen Advice)"
                        className="w-full border rounded-md px-3 py-2 mb-2 text-sm"
                        value={section.title}
                        onChange={(e) =>
                          handleSectionTitleChange(index, e.target.value)
                        }
                      />
                      {sections.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeSection(index)}
                          className="ml-2 text-red-500 hover:underline text-sm"
                        >
                          Remove
                        </button>
                      )}
                    </div>
                    <h1 className="text-lg text-left font-semibold">
                      Content
                      <span className="text-sm font-thin text-rose-800">
                        {" "}
                        (When u upload new description old one will be deleted)
                      </span>
                    </h1>
                    <TextEditor
                      onChange={(html) =>
                        handleSectionContentChange(index, html)
                      }
                      initialContent={section.content}
                    />
                  </div>
                ))}

                <button
                  type="button"
                  onClick={addSection}
                  className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700"
                >
                  + Add New Content
                </button>
              </div>
            </div>
            <div className="mt-10">
              <button
                type="submit"
                className="block w-full rounded-md px-3.5 py-2.5 text-center text-sm font-semibold text-white bg-blue-600 hover:bg-yellow-400 hover:text-black"
              >
                Update Product
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EditProductInfo;
